import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Daundtokonkandarshanbus() {



  const cardData =
  {
    keyword: 'Daund to Konkan Darshan Bus On Rent',
    heading: 'Sanavi Travels: Daund to Konkan Darshan Bus On Rent',
    headingDescription: 'Sanavi Travels offers reliable Daund to Konkan Darshan Bus On Rent, providing safe, comfortable, and convenient transportation for families, groups, corporate trips, and tourists traveling from Daund to the scenic Konkan region. Our fleet of well-maintained AC and non-AC buses ensures spacious seating, smooth rides, and ample luggage space for a hassle-free journey. With professional drivers, flexible one-way and round-trip rental packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free travel. We provide convenient pickup and drop services across Daund, Pune, and nearby areas, covering popular Konkan destinations and sightseeing spots. Choose Sanavi Travels for trusted Daund to Konkan Darshan bus rental services, delivering comfort, safety, and a seamless travel experience for every occasion.',

    top: 'Top Places to Visit in Konkan with Sanavi Travels',


"topPlaces": [
  {
    "title": "Ganpatipule Beach",
    "description": "Ganpatipule Beach is a pristine sandy beach on the Konkan coast, famous for its clear waters and the 400-year-old Swayambhu Ganpati temple nearby. It offers a peaceful retreat, ideal for relaxation, swimming, and witnessing stunning sunsets."
  },
  {
    "title": "Ratnagiri Fort",
    "description": "Ratnagiri Fort, also known as Ratnadurg, overlooks the Arabian Sea and offers panoramic coastal views. The fort features historic cannons, bastions, and a lighthouse, making it a popular spot for history enthusiasts and photographers."
  },
  {
    "title": "Jaigad Fort",
    "description": "Jaigad Fort is a coastal fort situated at the confluence of the Shastri River and Arabian Sea. Surrounded by scenic cliffs and sea views, it provides trekking opportunities and insight into Maratha-era defense architecture."
  },
  {
    "title": "Tarkarli Beach",
    "description": "Tarkarli Beach is known for its white sands, clear waters, and water sports like snorkeling and scuba diving. It is a perfect destination for adventure lovers and marine enthusiasts exploring the Konkan coastline."
  },
  {
    "title": "Velas Turtle Festival",
    "description": "Velas Beach hosts the annual Olive Ridley Turtle Festival, where visitors can witness baby turtles hatching and returning to the sea. The festival promotes eco-tourism and conservation awareness in the Konkan region."
  },
  {
    "title": "Kunkeshwar Temple",
    "description": "Kunkeshwar Temple is an ancient Shiva temple located on the Konkan coast. The temple’s serene surroundings and coastal views make it a spiritual and scenic destination for pilgrims and tourists."
  },
  {
    "title": "Bhatye Beach",
    "description": "Bhatye Beach, near Ratnagiri, offers calm waters, local fishing activity, and scenic surroundings. It is less crowded and ideal for quiet walks, nature photography, and enjoying the coastal lifestyle."
  },
  {
    "title": "Shivaji Maharaj Museum",
    "description": "The museum in Ratnagiri showcases the life, artifacts, and legacy of Chhatrapati Shivaji Maharaj. Visitors gain historical insights into the Maratha empire and Konkan’s heritage."
  },
  {
    "title": "Anjarle Beach and Ganesh Temple",
    "description": "Anjarle Beach is home to the Kadyavarcha Ganpati Temple, an important pilgrimage site. The beach offers a tranquil environment and scenic views, combining spiritual and natural beauty."
  },
  {
    "title": "Harihareshwar Beach",
    "description": "Harihareshwar is known for its beautiful beach, serene surroundings, and the Harihareshwar Temple. It is a peaceful destination for meditation, photography, and enjoying the coastal landscape."
  }
]
,



"services": [
  {
    "name": "Daund to Konkan Darshan Bus On Rent",
    "description": "Daund to Konkan Darshan Bus On Rent offers a convenient and comfortable travel solution for exploring the scenic Konkan region from Daund. Equipped with well-maintained AC buses, spacious seating, luggage storage, and professional chauffeurs, it ensures a safe and relaxing journey. Ideal for families, friends, corporate groups, and tour enthusiasts, this service allows travelers to enjoy picturesque coastal routes, hill stations, and historic towns of Konkan with ease and comfort."
  },
  {
    "name": "Konkan Darshan Bus from Daund",
    "description": "Konkan Darshan Bus from Daund provides organized and efficient bus travel for sightseeing tours across the Konkan region. With air-conditioned interiors, comfortable seating, and experienced drivers, it is perfect for tourists, family groups, and corporate outings seeking a seamless journey along the coastal landscapes, beaches, and heritage sites of Konkan."
  },
  {
    "name": "AC Bus Konkan Tour",
    "description": "AC Bus Konkan Tour ensures travelers experience a cool and comfortable ride while visiting Konkan’s beaches, waterfalls, forts, and hill stations. With air-conditioned buses, ample seating, luggage storage, and skilled chauffeurs, it guarantees a smooth, safe, and enjoyable travel experience suitable for families, friends, and corporate groups."
  },
  {
    "name": "Luxury Bus Konkan Darshan",
    "description": "Luxury Bus Konkan Darshan offers a premium travel experience with plush seating, spacious interiors, and professional chauffeurs. Ideal for VIP groups, family vacations, and corporate tours, this service provides comfort, style, and convenience for exploring the scenic Konkan coastline and cultural landmarks."
  },
  {
    "name": "Family Bus Konkan Tour",
    "description": "Family Bus Konkan Tour is designed for safe and enjoyable family trips. With air-conditioned buses, comfortable seating, and professional drivers, families can relax and enjoy Konkan’s picturesque landscapes, serene beaches, and cultural sites while ensuring safety and convenience throughout the journey."
  },
  {
    "name": "Group Travel Bus Konkan",
    "description": "Group Travel Bus Konkan caters to friends, corporate teams, school groups, and other large gatherings planning a trip along the Konkan coast. With AC interiors, spacious seating, and experienced drivers, it ensures hassle-free, organized, and enjoyable group travel for sightseeing, weekend getaways, and leisure tours."
  },
  {
    "name": "Affordable Bus Konkan Darshan",
    "description": "Affordable Bus Konkan Darshan provides budget-friendly travel solutions without compromising on comfort or safety. Suitable for families, student groups, corporate travelers, and friends, it offers spacious AC buses, reliable chauffeurs, and smooth travel along the scenic Konkan routes."
  },
  {
    "name": "Chauffeur Driven Bus Konkan",
    "description": "Chauffeur Driven Bus Konkan offers stress-free travel with professional drivers handling navigation, traffic, and passenger safety. Ideal for corporate outings, family trips, and group excursions, this service ensures a comfortable and memorable journey across the Konkan region."
  },
  {
    "name": "Best Konkan Bus Daund",
    "description": "Best Konkan Bus Daund provides top-quality bus services with AC interiors, spacious seating, skilled drivers, and well-maintained vehicles. Perfect for long-distance travel, family vacations, corporate tours, and weekend getaways, it guarantees a safe, comfortable, and punctual journey along Konkan’s scenic coastal routes."
  },
  {
    "name": "Tourist Bus Konkan",
    "description": "Tourist Bus Konkan is designed for travelers seeking sightseeing and leisure tours along Konkan’s beaches, forts, waterfalls, and hill stations. Equipped with AC buses, comfortable seating, and experienced chauffeurs, it ensures a smooth and enjoyable travel experience for tourists and groups."
  },
  {
    "name": "Coastal Tour Bus",
    "description": "Coastal Tour Bus provides specialized transport for exploring the beautiful Konkan coastline. With comfortable AC seating, luggage space, and professional drivers, it offers a safe and relaxing travel experience for families, friends, and corporate travelers visiting beaches, forts, and scenic coastal villages."
  },
  {
    "name": "Online Bus Booking Daund",
    "description": "Online Bus Booking Daund allows travelers to easily reserve Konkan tour buses from Daund through a simple online platform. With instant confirmation, flexible scheduling, and hassle-free management, it ensures smooth travel planning for families, corporate groups, and tourists."
  },
  {
    "name": "Religious Tour Bus",
    "description": "Religious Tour Bus provides dedicated transport for pilgrimages and spiritual journeys along the Konkan region. With air-conditioned interiors, comfortable seating, and professional drivers, it ensures safe, convenient, and stress-free travel for devotees visiting temples, shrines, and holy sites."
  },
  {
    "name": "Daund Konkan Travel Bus",
    "description": "Daund Konkan Travel Bus offers reliable and comfortable long-distance transport from Daund to various destinations in the Konkan region. With spacious AC buses, skilled chauffeurs, luggage storage, and punctual service, it ensures a smooth and enjoyable travel experience for families, tourists, and corporate groups."
  },
  {
    "name": "Konkan Trip Bus",
    "description": "Konkan Trip Bus provides organized bus services for sightseeing, leisure, and group travel along the Konkan coast. Equipped with AC interiors, comfortable seating, and professional drivers, it guarantees a safe, convenient, and memorable journey for weekend trips, family vacations, and corporate tours."
  }
],
"tableData": [
  ["Daund to Konkan Darshan Bus On Rent", "Konkan Darshan Bus from Daund"],
  ["AC Bus Konkan Tour", "Luxury Bus Konkan Darshan"],
  ["Family Bus Konkan Tour", "Group Travel Bus Konkan"],
  ["Affordable Bus Konkan Darshan", "Chauffeur Driven Bus Konkan"],
  ["Best Konkan Bus Daund", "Tourist Bus Konkan"],
  ["Coastal Tour Bus", "Online Bus Booking Daund"],
  ["Religious Tour Bus", "Daund Konkan Travel Bus"],
  ["Konkan Trip Bus", "—"]
]
,




"whychoose": [
  {
    "WhyChooseheading": "Daund to Konkan Darshan Bus On Rent with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers comfortable and reliable bus rental services from Daund to Konkan Darshan, perfect for scenic tours, family trips, group outings, and spiritual journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well‑Maintained Buses",
    "WhyChoosedescription": "Travel in air‑conditioned, clean, and regularly serviced buses that ensure a smooth and enjoyable journey from Daund to Konkan Darshan destinations."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, professional, and familiar with the Daund to Konkan Darshan route, ensuring safe and timely travel throughout your trip."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for Daund to Konkan Darshan bus rentals, inclusive of fuel, tolls, and driver allowances with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel queries, route planning, and itinerary updates for your Daund to Konkan Darshan trip."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Choose from one‑way, round‑trip, or customized bus rental packages based on your Daund to Konkan Darshan travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Daund to Konkan Darshan bus rentals."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services from Daund to Konkan Darshan?',
    answer: 'Yes, Sanavi Travels offers reliable and comfortable bus rentals from Daund to Konkan Darshan for scenic tours and group trips.'
  },
  {
    question: 'How can I book a Daund to Konkan Darshan bus rental?',
    answer: 'You can easily book through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for the Daund to Konkan Darshan route?',
    answer: 'Sanavi Travels provides air‑conditioned and well‑maintained buses suitable for long‑distance and scenic travel.'
  },
  {
    question: 'Are drivers experienced on the Daund to Konkan Darshan route?',
    answer: 'Yes, our drivers are professional, licensed, and familiar with the entire journey from Daund to Konkan Darshan destinations.'
  },
  {
    question: 'Can I customize my Daund to Konkan Darshan travel itinerary?',
    answer: 'Absolutely. You can select preferred stops, routes, and travel duration based on your trip preferences.'
  },
  {
    question: 'Is the bus rental service available 24x7?',
    answer: 'Yes, Sanavi Travels provides round‑the‑clock support and assistance throughout your Daund to Konkan Darshan bus trip.'
  },
  {
    question: 'Are the buses sanitized before departure?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized before every journey to ensure a safe and comfortable travel experience.'
  },
  {
    question: 'What payment options are available for booking?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Daund to Konkan Darshan bus trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohan Joshi',
    feedback: 'Booked a Daund to Konkan Darshan bus rental. Scenic journey, comfortable ride, and professional driver.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Priya Deshmukh',
    feedback: 'Excellent experience! The bus was clean, and the service was reliable and punctual throughout the Konkan Darshan trip.',
    rating: 5
  }
];





























































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Daund to Konkan Darshan Bus On Rent - Sanavi Travels",
  "description": "Sanavi Travels offers Daund to Konkan Darshan bus rentals for family trips, group travel, coastal tours, and religious excursions. AC and luxury chauffeur-driven buses available with online booking.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "87"
  }
};



  return (
    <div>
<Helmet>
  <title>
    Daund to Konkan Darshan Bus On Rent | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Daund to Konkan Darshan bus from Sanavi Travels for family trips, group travel, coastal tours, and religious excursions. AC and luxury chauffeur-driven buses available. Online booking available."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/113.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Daundtokonkandarshanbus;